import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5846a7cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-list-item__image-cont" }
const _hoisted_2 = { class: "menu-list-item__content" }
const _hoisted_3 = { class: "menu-list-item__title" }
const _hoisted_4 = {
  key: 0,
  class: "user-data-item__info"
}
const _hoisted_5 = {
  key: 0,
  class: "menu-list-item__actions"
}

import GoogleMaterialIcon from '@/common/components/helper-components/google-material-icon/google-material-icon.vue';

import { TMenuListItem } from './menu-list.types';
import CustomButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'menu-list-item',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
            'menu-list-item',
            __props.props.content ? '' : 'menu-list-item_centred',
        ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(GoogleMaterialIcon, {
        props: { iconName: __props.props.icon },
        class: "menu-list-item__icon"
      }, null, 8, ["props"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
                'menu-list-item__payload',
                __props.props.content ? '' : 'menu-list-item__payload_centred',
            ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.props.title), 1),
        (__props.props.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.props.content), 1))
          : _createCommentVNode("", true)
      ]),
      (__props.props.button)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(CustomButton, {
              props: __props.props.button,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.props.buttonCallback()))
            }, null, 8, ["props"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})